import { IGameResult } from "../type"
import json from "@project/data/rogue_4/game/result.json"
// FIXME remove example
import IMAGE01 from "@rogue_4/assets/img/game/result/01.png"
import IMAGE02 from "@rogue_4/assets/img/game/result/02.png"
import IMAGE03 from "@rogue_4/assets/img/game/result/03.png"

const GAME_RESULT_DICT: Record<string, IGameResult> = {
    "01": { ...json["01"], image: IMAGE01 },
    "02": { ...json["02"], image: IMAGE02 },
    "03": { ...json["03"], image: IMAGE03 },
}

export default GAME_RESULT_DICT
